export enum EfuneralServiceTier {
    BASIC = 'Basic',
    PRO = 'PRO',
    BUSINESS = 'Business',
    PARTNER = 'Partner',
    PREFERRED = 'Preferred',
    PREFERRED_PLUS = 'Preferred +',
}
